import React, { Component } from "react";
import { Button, Alert, Typography } from "antd";
//assets
import "../assets/shared.css";
import "../assets/loading.scss";
// components
import InstagramError from "./InstagramError";
import PaypalForm from "./PaypalForm";

//services
import * as backend from "../services/backend";
import { sendSlackMessage } from "../services/slack";
//antd
const ButtonGroup = Button.Group;
const { Title } = Typography;

class Instagram extends Component {
  state = {
    success: null, //null = loading, false = error, true = ok
    loadingMessage: "Checking your campaign completion", //changes after 5 sec
    animationDone: null,
    error: null, //error message
    complete: false, //show done
    askForPaypal: false, //show paypalForm
    postUrl: null, //value to manually submit
    invalidPostUrl: null, //form component validation
    paypalEmail: null, //value to manually submit
    invalidPaypal: null, //form component validation
    invalidPaypalMessage: null, //if invalidPaypal = error, show
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.post !== this.state.post) {
      //get vars
      const { post } = this.state;

      const shortcode = post.shortcodeId;

      const screenshot = post.metadata && post.metadata.manual_screenshot;
      if (screenshot) {
        this.setState({ imageUrl: screenshot });
        setTimeout(() => {
          //delay for animation
          this.setState({ animationDone: true });
        }, 800);
      } else {
        //load insta image
        fetch(
          `${process.env.REACT_APP_IG_EMBED_PREFIX}${shortcode}${
            process.env.REACT_APP_IG_EMBED_SUFFIX
          }`
        )
          .then(res => res.json())
          .then(json => {
            this.setState({ imageUrl: json.thumbnail_url });
            setTimeout(() => {
              //delay for animation
              this.setState({ animationDone: true });
            }, 800);
          })
          .catch(err => null); //do nothing if fails
      }

      //if product not paid, prompt for paypal
      if (
        post.productPayoutPaid === false ||
        (post.relations &&
          post.relations.payouts &&
          post.relations.payouts[0].payoutDate === null &&
          post.relations.payouts[0].upfront === false)
      ) {
        return this.setState({
          askForPaypal: true,
          success: true,
          shortcode,
        });
      }
      return this.setState({ complete: true, success: true });
    }
  }

  async componentDidMount() {
    // to match post based on id query string parameter
    let scrapingTimer;
    try {
      //if still loading after 5 seconds
      scrapingTimer = setTimeout(() => {
        this.setState({
          loadingMessage: "It's taking longer than usual... Please wait",
        });
      }, 5000);

      //get onboard status by id
      const id = this.props.qsParams.get("id");
      const onboard = await backend.getOnboardStatus(id);

      //if shortcode already exists dont scrape
      if (
        onboard.shortcodeId ||
        (onboard.metadata && onboard.metadata.manual_screenshot)
      )
        return this.setState({ post: onboard });

      //scrape
      const instaSubmit = await backend.putStepsDone(id, {
        stepType: "instagram",
      });
      if (typeof instaSubmit !== "object")
        //if doesnt return {prev, current}
        throw new Error(
          "Fetching post failed: " + (instaSubmit.message || instaSubmit)
        );
      this.setState({ post: instaSubmit });
    } catch (error) {
      console.log("error", error);
      this.setState({
        success: false,
        error: error.message || "Uknown Error",
      });
    } finally {
      //reset animation timer
      clearTimeout(scrapingTimer);
    }
  }

  postFoundButClickedNo = () => {
    this.setState({
      success: false,
      error:
        "Please input the correct post link below. If you clicked 'No' by accident, no further action is needed as we have marked your post as complete :)",
    });
  };

  submitPostUrl = async () => {
    //check if manual confirm is valid instagram link
    const validInstagramLink = new RegExp("(/p/([^\\s/?#\"'&\\\\]+)).*?")[
      Symbol.match
    ](this.state.postUrl);

    if (validInstagramLink && validInstagramLink[0]) {
      //complete post
      this.setState({
        invalidPostUrl: "success",
        complete: true,
        success: true,
      });

      const onboardWithTicketNumber = await backend.submitSupportTicket(
        this.props.qsParams.get("id"),
        {
          stepType: "instagram",
          link: this.state.postUrl,
        }
      );
    } else {
      //no regex match found
      this.setState({ invalidPostUrl: "error" });
    }
  };

  submitPaypal = async () => {
    //check if manual confirm is valid instagram link
    const validPaypal = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )[Symbol.match](this.state.paypalEmail);

    if (validPaypal && validPaypal[0]) {
      const id = this.state.post.onboardId;
      let submitPaypalError = false;
      //loading
      this.setState({
        animationDone: null,
        error: null, //error message
        complete: false, //show done
        success: null,
      });
      const paypalResponse = await backend
        .submitPaypal(id, this.state.paypalEmail)
        .then(res =>
          res.json().then(async json => {
            if (!res.ok) submitPaypalError = true;
            if (res.status >= 500)
              throw new Error(json.message || res.statusText);
            return json;
          })
        )
        .catch(async backendError => {
          console.log("backendError", backendError);
          submitPaypalError = true;
          process.env.NODE_ENV == "production" &&
            (await sendSlackMessage(
              `ERROR PAYPAL MANUAL SUBMIT: ${this.props.qsParams.get(
                "id"
              )} --- ${this.state.paypalEmail}\r\n${backendError.message}`
            ));
          return { message: backendError.message };
        });

      console.log("paypalResponse", paypalResponse);
      console.log("submitPaypalError", submitPaypalError);

      if (submitPaypalError) {
        this.setState({
          animationDone: true,
          success: true,
          invalidPaypal: "error",
          invalidPaypalMessage: paypalResponse.message,
        });
      } else {
        //complete if valid
        this.setState({ post: paypalResponse, askForPaypal: false });
      }
      //TODO: REDO CONFIRM UI
      //TODO: replace slack message reporting with outsourced approval ie. dashboards
    } else {
      //no regex match found
      this.setState({ invalidPaypal: "error", invalidPaypalMessage: null });
    }
  };
  /*
   * USED BY INSTAGRAM ERROR COMPONENT
   */
  handleInputChange = event => {
    //see https://reactjs.org/docs/forms.html
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div style={styles.flexColumnCenter}>
        <Title
          className={this.state.success === null && "loading"}
          level={3}
          style={styles.heading}
        >
          {this.state.askForPaypal && this.state.animationDone ? (
            <PaypalForm
              invalidPaypalMessage={this.state.invalidPaypalMessage}
              invalidPaypal={this.state.invalidPaypal}
              handleInputChange={this.handleInputChange}
              paypalEmail={this.state.paypalEmail}
              submitPaypal={this.submitPaypal}
            />
          ) : this.state.complete ? (
            "Thanks for confirming your post! Your campaign is now complete :)"
          ) : this.state.success === null ? (
            this.state.loadingMessage
          ) : this.state.success ? (
            this.state.animationDone ? (
              "Is this it?"
            ) : (
              "Found your post!"
            )
          ) : (
            <InstagramError
              error={this.state.error} //API error message
              invalidPostUrl={this.state.invalidPostUrl}
              handleInputChange={this.handleInputChange}
              postUrl={this.state.postUrl}
              submitPostUrl={this.submitPostUrl}
            />
          )}
        </Title>
        {this.state.success !== false &&
          (this.state.imageUrl &&
          this.state.animationDone &&
          !this.state.complete ? ( //if instagram code found
            <div style={styles.imageContainer}>
              {!this.state.askForPaypal && (
                <ButtonGroup>
                  <Button
                    style={{ marginRight: "24px" }}
                    onClick={() => {
                      this.setState({ complete: true });
                    }}
                    size="large"
                  >
                    Yes
                  </Button>
                  <Button size="large" onClick={this.postFoundButClickedNo}>
                    No
                  </Button>
                </ButtonGroup>
              )}
            </div>
          ) : (
            !this.state.animationDone && (
              <div style={styles.centered}>
                <div
                  className={
                    "circle-loader" +
                    (this.state.success === null ? "" : " load-complete")
                  }
                >
                  <div
                    className={
                      this.state.success === null ? "" : "checkmark draw"
                    }
                  />
                </div>
              </div>
            )
          ))}
        {this.state.imageUrl && this.state.animationDone && (
          <img style={styles.imageCard} src={this.state.imageUrl} />
        )}
      </div>
    );
  }
}

const styles = {
  imageCard: {
    objectFit: "contain",
    paddingTop: "6vh",
    maxHeight: "50vh",
    maxWidth: "100%",
  },
  imageContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColumnCenter: {
    width: "75vw",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  heading: { fontWeight: "300" },
  centered: {
    //centered in the middle of screen
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
};

export default Instagram;
